import { render, staticRenderFns } from "./ProgressFundamentalItem.vue?vue&type=template&id=324fe4b6&scoped=true&"
import script from "./ProgressFundamentalItem.vue?vue&type=script&lang=js&"
export * from "./ProgressFundamentalItem.vue?vue&type=script&lang=js&"
import style0 from "./ProgressFundamentalItem.vue?vue&type=style&index=0&id=324fe4b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fe4b6",
  null
  
)

export default component.exports